<template>
  <div class="search-container">
    <div class="search-left">
      <DynamicOption v-model="searchParams.channelId" :singleSelect="true" />
    </div>

    <div class="search-right">
      <el-button v-auth="'SECURITY_CHANNEL_CONFIG_SEARCH'" type="primary" size="small" @click="search">搜索</el-button>
      <el-button v-auth="'SECURITY_CHANNEL_CONFIG_ADD'" size="small" @click="add">新增</el-button>

    </div>
    <Add ref="add" />
  </div>
</template>

<script>
import DynamicOption from "@/components/DynamicOption/index.vue";
import Message from '@/components/Message';
import Add from './add.vue'
export default {
  name: 'WebSaaSSearch',
  inject: ['searchParams', 'loadList'],
  provide() {
    return {
      loadList: this.loadList,
    };
  },
  components: {
    Add,
    DynamicOption
  },
  data() {
    return {

    };
  },

  methods: {
    /** 搜索的方法 */
    async search() {
      this.searchParams.current = 1;
      await this.loadList();
      Message.success('搜索成功');
    },
    /** 新增 */
    add() {
      this.$refs.add.show('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;

  // .search-left {
  //   flex: 1;
  // }

  .search-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>